module.exports = __webpack_public_path__ + "static/media/logo-apra.afc6805d.png";